"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;

var _react = _interopRequireDefault(require("react"));

function index(props) {
  var content = props.content,
      backgroundUrl = props.backgroundUrl,
      contentColor = props.contentColor;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'short-banner-wrap',
    style: backgroundUrl ? {
      background: "url(" + backgroundUrl + ") center no-repeat",
      backgroundSize: 'cover'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "short-banner-main"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'short-banner',
    style: {
      color: contentColor
    }
  }, content))));
}